import { Paragraph, Title } from '@cambridgeassessment/cambridge-ui';
import styled from 'styled-components';

export const StyledParagraph = styled(Paragraph)`
  margin-bottom: 32px;
`;

export const StyledTitle = styled(Title)`
  margin-bottom: 24px;
  margin-top: 32px;
`;

export const ButtonWrapper = styled.div`
  margin-top: 32px;
`;

export const StyledResultsBlock = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 1254px;
`;

export const LineClamp = styled.span<{ linesCount?: number }>`
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: ${(props) => props.linesCount ?? 2};
  -webkit-box-orient: vertical;
`;
